import moment from 'moment'
import {
  FileStatusRenderer,
  DownloadCellRenderer,
  MaintainLinkCellRenderer,
  ValidationStatus,
} from '../views/bulkItem/uploadHistory/GridHelper'
import { MS_24H } from '../constants/gridConstants'

export const formatDate = (isoDate) => {
  // Create Date object
  const date = new Date(isoDate)
  if (isNaN(date.getTime())) {
    return ''
  }
  // Format components in UTC
  const day = String(date.getUTCDate()).padStart(2, '0')
  const monthShort = date.toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC',
  })
  const year = date.getUTCFullYear()

  // Format time (24-hour format) in UTC
  const hours = String(date.getUTCHours()).padStart(2, '0')
  const minutes = String(date.getUTCMinutes()).padStart(2, '0')
  const seconds = '00' // as per your expected output

  return `${day} ${monthShort}, ${year} ${hours}:${minutes}:${seconds}`
}
export const getFormattedLocalTime = () => {
  const now = new Date()

  const day = now.getDate().toString().padStart(2, '0')
  const month = now.toLocaleString('default', { month: 'short' }) // "May"
  const year = now.getFullYear()

  const hours = now.getHours().toString().padStart(2, '0')
  const minutes = now.getMinutes().toString().padStart(2, '0')
  const seconds = now.getSeconds().toString().padStart(2, '0')

  return `${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`
}
const componentTypeMapper = (column) => {
  switch (column) {
    case 'maintainLink':
      return MaintainLinkCellRenderer
    case 'file_status':
      return FileStatusRenderer
    case 'download':
      return DownloadCellRenderer
    case 'validation_status':
      return ValidationStatus
    default:
      return
  }
}
const parseUploadedOn = (s) => {
  if (!s) return null
  // eslint-disable-next-line
  const hasTZ = /([zZ]|[+\-]\d{2}:?\d{2})$/.test(s)
  const normalized = hasTZ ? s : `${s}Z`
  const d = new Date(normalized)
  return isNaN(d.getTime()) ? null : d
}
export const isWithinLast24H = (uploadedOn) => {
  const d = parseUploadedOn(uploadedOn)
  return d ? Date.now() - d.getTime() <= MS_24H : false
}

export const mapResponse = (input) => {
  const transformed = input.map((item) => {
    const itemTypes = item?.item_type_summaries
    const itemType = itemTypes?.map((s) => `${s.item_type}`).join(', ')
    const itemTypeId = itemTypes?.map((s) => `${s.item_type_id}`).join(', ')
    const success = itemTypes?.reduce((sum, s) => sum + s.success_count, 0)
    const failure = itemTypes?.reduce((sum, s) => sum + s.failed_count, 0)

    /**** When multiple item types are present *****/
    /*
      const reason = itemTypes
        ?.map((s) => `${s.template_validation_failure_message}`)
        .join(', ')

     */
    const reason = item.file_validation_message
    const status =
      ((itemTypes && itemTypes[0]) || {}).template_validation_status || ''

    return {
      id: item.request_id,
      request_file_name: item.request_file_name,
      uploaded_on: moment
        .utc(formatDate(item.uploaded_on), 'DD MMM, YYYY HH:mm:ss')
        .add(11, 'hours')
        .format('DD MMM, YYYY HH:mm:ss'),
      request_status: item.request_status,
      item_type: itemType,
      item_type_id: itemTypeId,
      validation_status: status,
      reason: reason,
      num_units_success: success,
      num_units_failure: failure,
    }
  })
  return transformed
}

export const UPLOAD_HISTORY_COLUMNS = [
  { field: 'id', headerName: 'Request Id', width: 200 },
  {
    field: 'request_file_name',
    headerName: 'Filename',
    width: 240,
  },
  {
    field: 'uploaded_on',
    headerName: 'Uploaded on',
    width: 200,
  },
  {
    field: 'request_status',
    headerName: 'File Status',
    cellRenderer: componentTypeMapper('file_status'),
    width: 200,
    cellClass: 'with-tooltip',
  },
  {
    field: 'item_type',
    headerName: 'Item type',
    width: 250,
  },
  {
    field: 'validation_status',
    headerName: 'Item validation status',
    cellRenderer: componentTypeMapper('validation_status'),
    width: 240,
  },
  {
    field: 'image',
    headerName: 'Actions',
    cellRenderer: componentTypeMapper('download'),
    suppressKeyboardEvent: () => true, // prevents duplicate navigation
    cellClass: 'non-focusable-cell',
    width: 250,
    filter: false,
    suppressHeaderMenuButton: true,
  },
]
